﻿import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { UserMenu } from '../models/user-menu';
import { resourceServerUrl } from '../constants/auth-keys';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class UserInformationService {
    
    private currentlyLoggedOnUserUrl: string = `${resourceServerUrl}/CurrentlyLoggedOnUser`;
    private userMenurUrl: string = `${resourceServerUrl}/menu`;
    private photoURI: string = `${resourceServerUrl}/api/user/photo`;

    public headerInformationSource = new BehaviorSubject<any>(undefined);
    public headerPhotoSource = new BehaviorSubject<any>(undefined);

    constructor(private http: HttpClient) { }

    getCurrentUser(): Observable<HttpResponse<any>> {
        return this.http.get(this.currentlyLoggedOnUserUrl, { observe: 'response' });
    }

    getCurrentUserMenu(): Observable<UserMenu[]> {
        return this.http.get<UserMenu[]>(this.userMenurUrl);
    }

    getCurrentUserPhoto(): Observable<any> {
        return this.http.get(this.photoURI);
    }

    changeHeaderInformation(information: any) {
        this.headerInformationSource.next(information);
    }

    changeHeaderPhoto(photo: any) {
        this.headerPhotoSource.next(photo);
    }
}